import { useTranslation } from "react-i18next";
import { getCurrentCurrency } from "@/utils/countryConfigUtils";

export const useTranslationPlus = (prefix?) => {
    const { t: trans, i18n } = useTranslation();
    const t = (key: string, options?: any): any => {
        const mergedOptions = {
            currency: getCurrentCurrency(),
            ...options,
        };
        if (key?.includes('.')) {
            // 如果 key 已经以 prefix 开头，则不重复添加
            if (prefix && key.startsWith(prefix + '.')) {
                return trans(key, mergedOptions);
            }
            // 如果 key 包含 '.' 但未以 prefix 开头，则添加 prefix
            const index = prefix ? prefix + '.' + key : key;
            return trans(index, mergedOptions);
        }
        const index = prefix ? prefix + '.' + key : key;
        return trans(index, mergedOptions);
    };
    return {
        t,
        i18n
    };
};
